import { render, staticRenderFns } from "./ContractTableForm.vue?vue&type=template&id=0ad50871&scoped=true&"
import script from "./ContractTableForm.vue?vue&type=script&lang=js&"
export * from "./ContractTableForm.vue?vue&type=script&lang=js&"
import style0 from "./ContractTableForm.vue?vue&type=style&index=0&id=0ad50871&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad50871",
  null
  
)

export default component.exports